import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Select,
  MenuItem,
  Grid,
  Card,
  Box,
  CardContent,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { FaLayerGroup } from "react-icons/fa";
import download from "./assets/MyImg/set-download.png";
import icon from "./assets/MyImg/blck_icon.png";
import icon1 from "./assets/MyImg/call.png";
import icon2 from "./assets/MyImg/set-icon2.png";
import icon3 from "./assets/MyImg/set-icon3.png";
import icon4 from "./assets/MyImg/icon.png";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import GridViewIcon from "@mui/icons-material/GridView";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import HeaderSection from "./HeaderSection";
import Typography from "@mui/material/Typography";
import Delete from "@mui/icons-material/Delete";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CircularProgress from "@mui/material/CircularProgress";

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

const SetProduct = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md")); // Check for mobile or tablet view
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    image: download,
    imageName: "",
    name: "",
    category: "",
    state: "India",
    company: "",
    phone: "",
    setprice: "",
    setdiscount: "",
  });
  const [editingProduct, setEditingProduct] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [open, setOpen] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [addCategoryDialogOpen, setAddCategoryDialogOpen] = useState(false);
  const [editCategoryDialogOpen, setEditCategoryDialogOpen] = useState(false); // State for edit category dialog
  const [categoryFields, setCategoryFields] = useState({
    field1: "",
    field2: "",
    field3: "",
    field4: "",
  });
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("all");
  const [deleteCategoryDialogOpen, setDeleteCategoryDialogOpen] = useState(false); // State for delete confirmation dialog
  const [categoryToDelete, setCategoryToDelete] = useState(""); // State for the category to delete
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [addSuccessDialogOpen, setAddSuccessDialogOpen] = useState(false); // <-- Add this state
  const [errorDialog, setErrorDialog] = useState({ open: false, message: "" }); // Add this state

  const handleOpenDeleteCategoryDialog = (categoryName) => {
    setCategoryToDelete(categoryName);
    setDeleteCategoryDialogOpen(true);
  };

  const handleCloseDeleteCategoryDialog = () => {
    setDeleteCategoryDialogOpen(false);
    setCategoryToDelete("");
  };

  const handleConfirmDeleteCategory = async () => {
    try {
      const response = await fetch(`https://enzo-matr.onrender.com/api/categories/${categoryToDelete}`, {
        method: "DELETE",
      });
      if (!response.ok) {
        throw new Error("Failed to delete category");
      }
      setCategories(categories.filter((category) => category !== categoryToDelete)); // Update frontend
      setDeleteCategoryDialogOpen(false);
      setCategoryToDelete("");
    } catch (error) {
      console.error("Error deleting category:", error.message);
    }
  };

  // Fetch products and categories from the backend
  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const response = await fetch("https://enzo-matr.onrender.com/api/products");
        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const response = await fetch("https://enzo-matr.onrender.com/api/categories");
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        const data = await response.json();
        setCategories(data.map(category => category.name));
      } catch (error) {
        setError(error.message);
      }
    };

    fetchProducts();
    fetchCategories();
  }, []);

  const handleAddProduct = async () => {
    if (!newProduct.name || !newProduct.category || !newProduct.company || !newProduct.phone) {
      alert("Please enter all fields.");
      return;
    }

    try {
      const response = await fetch("https://enzo-matr.onrender.com/api/products", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newProduct),
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.message === "Product with the same name already exists in another category") {
          setErrorDialog({
            open: true,
            message: "This product name is already used in another category.",
          });
        } else {
          throw new Error(errorData.message || "Failed to add product");
        }
        return;
      }

      const addedProduct = await response.json();
      setProducts([addedProduct, ...products]);
      setNewProduct({
        image: download,
        imageName: "",
        name: "",
        category: "",
        state: "India",
        company: "",
        phone: "",
        setprice: "",
        setdiscount: "",
      });
      setAddSuccessDialogOpen(true); // <-- Show success dialog
    } catch (error) {
      console.error("Error adding product:", error.message);
      setError(error.message);
    }
  };

  // Delete a product
  const handleDelete = async () => {
    if (!productToDelete) {
      console.error("No product ID provided for deletion");
      return;
    }

    try {
      const response = await fetch(`https://enzo-matr.onrender.com/api/products/${productToDelete}`, {
        method: "DELETE",
      });
      if (!response.ok) {
        throw new Error("Failed to delete product");
      }
      setProducts(products.filter((product) => product._id !== productToDelete));
      setDeleteDialogOpen(false);
    } catch (error) {
      console.error("Error deleting product:", error.message);
      setError(error.message);
    }
  };

  // Save edited product
  const handleSaveEdit = async () => {
    if (!editingProduct || !editingProduct._id) {
      console.error("No product selected for editing");
      return;
    }

    try {
      const response = await fetch(`https://enzo-matr.onrender.com/api/products/${editingProduct._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newProduct),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update product");
      }

      const updatedProduct = await response.json();
      setProducts(products.map((product) =>
        product._id === updatedProduct._id ? updatedProduct : product
      ));

      setEditingProduct(null);
      setNewProduct({
        image: download,
        imageName: "",
        name: "",
        category: "",
        state: "India",
        company: "",
        phone: "",
        setprice: "",
        setdiscount: "",
      });
    } catch (error) {
      console.error("Error updating product:", error.message);
      setError(error.message);
    }
  };

  // Filter products based on search and country
  const filteredProducts = products
  .filter((product) => {
    const matchesSearch =
      product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.company.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCountry =
      selectedCountry === "all" || product.state.toLowerCase() === selectedCountry.toLowerCase();
    return matchesSearch && matchesCountry;
  })
  .sort((a, b) => (b._id > a._id ? 1 : -1)); // Newest first

  // Add category dialog
  const handleAddCategoryDialogOpen = () => {
    setAddCategoryDialogOpen(true);
  };

  const handleAddCategoryDialogClose = () => {
    setAddCategoryDialogOpen(false);
  };

  const handleEditCategoryDialogOpen = () => {
    setEditCategoryDialogOpen(true);
  };

  const handleEditCategoryDialogClose = () => {
    setEditCategoryDialogOpen(false);
  };

  const handleCategoryFieldChange = (field, value) => {
    setCategoryFields({ ...categoryFields, [field]: value });
  };

  const handleCategorySubmit = async () => {
    if (categoryFields.field1.trim()) {
      try {
        const response = await fetch("https://enzo-matr.onrender.com/api/categories", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name: categoryFields.field1 }),
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to add category");
        }
        const addedCategory = await response.json();
        setCategories([...categories, addedCategory.name]);
        setCategoryFields({ ...categoryFields, field1: "" });
        setAddCategoryDialogOpen(false);
      } catch (error) {
        console.error("Error adding category:", error.message);
        setError(error.message);
      }
    } else {
      alert("Please enter a category name.");
    }
  };

  const handleDeleteCategory = async (categoryName) => {
    try {
      const response = await fetch(`https://enzo-matr.onrender.com/api/categories/${categoryName}`, {
        method: "DELETE",
      });
      if (!response.ok) {
        throw new Error("Failed to delete category");
      }
      setCategories(categories.filter((category) => category !== categoryName)); // Update frontend
    } catch (error) {
      console.error("Error deleting category:", error.message);
    }
  };

  return (
    <>
      <HeaderSection />
      <Box sx={{ bgcolor: "#20a4a3", p: 1, textAlign: "center", marginBottom: "0px", marginTop: "-10px" }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", color: "white", fontFamily: "caladea" }}>
          SET PRODUCT
        </Typography>
      </Box>
      <Grid
        container
        spacing={2}
        sx={{
          padding: 2,
          marginTop: 0,
          height: "auto",
          background: "#f8f9fa",
          flexDirection: isMobileOrTablet ? "column" : "row", // <-- change here
        }}
      >
        <Grid
          item
          xs={12}
          md={8.6}
          sx={{
            marginBottom: isMobileOrTablet ? "16px" : "2px",
            height: isMobileOrTablet ? "auto" : "100%",
            mt: isMobileOrTablet ? 0 : -2,
          }}
        >
          <Card sx={{ height: isMobileOrTablet ? "auto" : "102%" }}>
            <CardContent
              sx={{
                height: isMobileOrTablet ? "auto" : "95%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid container spacing={0.5} alignItems="center" sx={{ marginBottom: "5px" }}>
                <Grid item xs={4}>
                  <TextField
                    variant="outlined"
                    placeholder="Search Item"
                    size="small"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                      sx: { borderRadius: "10px", border: "1px solid" },
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item>
                  <IconButton sx={{ background: "black", color: "white", borderRadius: "10px" }}>
                    <SearchIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ background: "#25bdbe", color: "black", border: "1px solid", borderRadius: "10px", fontFamily: "source serif pro", fontSize: "16px", fontWeight: "bold", textTransform: "none" }}
                    fullWidth
                    onClick={() => setSelectedCountry("india")} // Filter by "India"
                  >
                    Indian
                  </Button>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ background: "#25bdbe", color: "black", textTransform: "none", border: "1px solid", borderRadius: "10px", fontFamily: "source serif pro", fontSize: "16px", fontWeight: "bold" }}
                    fullWidth
                    onClick={() => setSelectedCountry("saudi")} // Filter by "Saudi"
                  >
                    Saudi
                  </Button>
                </Grid>
                <Grid item xs={3} >
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{ background: "#2f2f2f", color: "white", textTransform: "none", border: "1px solid", borderRadius: "10px", fontFamily: "source serif pro", fontSize: "16px", fontWeight: "bold" }}
                    onClick={() => setSelectedCountry("all")} // Reset filter
                  >
                    View All
                  </Button>
                </Grid>
              </Grid>
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: 2,
                  border: "1px solid #ddd",
                  width: "100%",
                  flex: 1,
                  maxHeight: isMobileOrTablet ? 420 : 467,
                  overflowY: "auto",
                  msOverflowStyle: "none",
                  "&::-webkit-scrollbar": { display: "none" },
                }}
              >
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: isMobileOrTablet ? 220 : 467,
                      minHeight: 180,
                    }}
                  >
                    <CircularProgress size={60} sx={{ color: "#25bdbe" }} />
                  </Box>
                ) : (
                  <Table stickyHeader>
                    <TableHead sx={{ bgcolor: "#333" }}>
                      <TableRow>
                        <TableCell sx={{ color: "white", fontWeight: "bold", bgcolor: "black" }}>Image</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold", bgcolor: "black" }}>Product Detail</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold", bgcolor: "black" }}>Category</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold", bgcolor: "black" }}>Country</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold", bgcolor: "black" }}>Company</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold", bgcolor: "black" }}>Phone No</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold", bgcolor: "black" }}>Price</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold", bgcolor: "black" }}>Discount</TableCell>
                        <TableCell sx={{ color: "white", textAlign: "center", bgcolor: "black", fontWeight: "bold" }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredProducts.map((product) => (
                        <TableRow key={product._id}>
                          <TableCell>
                            <img
                              src={product.image}
                              alt="Product Logo"
                              style={{ width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer" }}
                              onClick={() => {
                                setPreviewImageSrc(product.image);
                                setImagePreviewOpen(true);
                              }}
                            />
                          </TableCell>

                          <TableCell>
                            <b>{product.name}</b>

                          </TableCell>
                          <TableCell >
                            {product.category}
                          </TableCell>
                          <TableCell>{product.state}</TableCell>
                          <TableCell>{product.company}</TableCell>
                          <TableCell>{product.phone}</TableCell>
                          <TableCell>{product.setprice}</TableCell>
                          <TableCell>{product.setdiscount}</TableCell>

                          <TableCell>
                            <Box sx={{ whiteSpace: "nowrap" }}>
                              <IconButton sx={{
                                bgcolor: "#20a4a5", color: "white", borderRadius: "10px", border: "2px solid black", width: "40px", height: "40px", marginRight: "5px", "&:hover": { bgcolor: "#1a8a8a" },
                              }}
                                onClick={() => {
                                  setEditingProduct(product);
                                  setNewProduct({ ...product }); // Populate newProduct with the product data
                                }}>
                                <FaEdit style={{ fontSize: "20px" }} />
                              </IconButton>
                              <IconButton
                                sx={{
                                  bgcolor: "#bb1726",
                                  color: "white",
                                  borderRadius: "10px",
                                  border: "2px solid black",
                                  width: "40px",
                                  height: "40px",
                                  "&:hover": { bgcolor: "#a01522" },
                                }}
                                onClick={() => {
                                  setProductToDelete(product._id);
                                  setDeleteDialogOpen(true);
                                }}
                              >
                                <RiDeleteBin5Line style={{ fontSize: "20px" }} />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>

        {/* Right Side Section */}
        <Grid
          item
          xs={12}
          md={3.4}
          container
          spacing={0.5}
          sx={{
            height: isMobileOrTablet ? "auto" : "569px",
            mt: isMobileOrTablet ? 0 : -2,
          }}
        >
          <Card
            sx={{
              flex: 1,
              p: 0,
              bgcolor: "#f8f9fa",
              height: isMobileOrTablet ? "auto" : "100%",
            }}
          >
            <CardContent sx={{ marginTop: isMobileOrTablet ? "0" : "-5px" }}>
              <h3 style={{ textAlign: "center", marginTop: 0 }}>{editingProduct ? "Edit Product" : "Add New Product"}</h3>
              <Grid container spacing={1} sx={{ mt: -3 }}>
                <Grid item xs={12}>
                  <TextField
                    label="Enter Product"
                    value={newProduct.name}
                    onChange={(e) => setNewProduct({ ...newProduct, name: e.target.value })}
                    fullWidth
                    size="small"
                    sx={{ "& .MuiInputBase-root": { height: "46px", fontWeight: "bold" } }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <img
                            src={icon2}
                            alt="icon"
                            style={{ width: "30px", height: "30px" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    name="imageName"
                    placeholder="Add Image"
                    value={newProduct.imageName || ""}
                    InputProps={{
                      sx: { borderRadius: "10px" },
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton component="label">
                            <AddPhotoAlternateIcon sx={{ color: "gray" }} />
                            <input
                              type="file"
                              accept="image/*"
                              hidden
                              onChange={async (event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const base64 = await fileToBase64(file);
                                  setNewProduct({
                                    ...newProduct,
                                    imageName: file.name,
                                    image: base64, // Store as base64
                                  });
                                }
                              }}
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                      endAdornment: newProduct.imageName && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              setNewProduct({ ...newProduct, imageName: "", image: "" })
                            }
                          >
                            <Delete sx={{ color: "red" }} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& input::placeholder": {
                        fontWeight: "bold",
                        fontSize: "0.8rem",
                        fontFamily: "'Bricolage Grotesque', sans-serif",
                      },
                      "& input": {
                        fontFamily: "'Bricolage Grotesque', sans-serif",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="category-label">Category</InputLabel>
                    <Select
                      labelId="category-label"
                      value={newProduct.category || ""}
                      onChange={(e) => setNewProduct({ ...newProduct, category: e.target.value })}
                      label="Category"
                      fullWidth
                      IconComponent={() => <ArrowDropDownIcon style={{ color: "grey", opacity: 0.5 }} />}
                      sx={{ height: "46px" }}
                    >
                      <MenuItem value="">
                        <em>Select Category</em>
                      </MenuItem>
                      {categories.map((category, index) => (
                        <MenuItem key={index} value={category}>
                          {category}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Select
                    value={newProduct.state}
                    onChange={(e) => setNewProduct({ ...newProduct, state: e.target.value })}
                    fullWidth
                    size="small"
                    sx={{ "& .MuiInputBase-root": { height: "36px" } }}
                  >
                    <MenuItem value="India">India</MenuItem>
                    <MenuItem value="Saudi">Saudi</MenuItem>
                  </Select>
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label="Enter Company"
                    value={newProduct.company}
                    onChange={(e) => setNewProduct({ ...newProduct, company: e.target.value })}
                    fullWidth
                    size="small"
                    sx={{ "& .MuiInputBase-root": { height: "46px" } }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <img
                            src={icon4}
                            alt="icon"
                            style={{ width: "30px", height: "30px" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Number"
                    value={newProduct.phone}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        setNewProduct({ ...newProduct, phone: value });
                      }
                    }}
                    fullWidth
                    size="small"
                    sx={{ "& .MuiInputBase-root": { height: "46px" } }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <img
                            src={icon1}
                            alt="icon"
                            style={{ width: "30px", height: "20px" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Price"
                    value={newProduct.setprice}
                    onChange={(e) => setNewProduct({ ...newProduct, setprice: e.target.value })}
                    fullWidth
                    size="small"
                    sx={{ "& .MuiInputBase-root": { height: "46px" } }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <img
                            src={icon3}
                            alt="icon"
                            style={{ width: "30px", height: "30px" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Discount"
                    value={newProduct.setdiscount}
                    onChange={(e) => setNewProduct({ ...newProduct, setdiscount: e.target.value })}
                    fullWidth
                    size="small"
                    sx={{ "& .MuiInputBase-root": { height: "46px" } }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <img
                            src={icon}
                            alt="icon"
                            style={{ width: "30px", height: "30px" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    startIcon={<AddIcon style={{ fontSize: "36px" }} />}
                    sx={{ marginTop: -0.3, background: "#2f2f2f", color: "white", height: "44px", fontFamily: "caladea", fontSize: "15px", fontWeight: "bold" }}
                    onClick={editingProduct ? handleSaveEdit : handleAddProduct}
                  >
                    {editingProduct ? "SAVE CHANGES" : "ADD PRODUCT"}
                  </Button>
                </Grid>
                <Grid container spacing={1.5} sx={{ mt: 3, p: 2, width: '480px' }}>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      endIcon={<GridViewIcon sx={{ fontSize: '78px' }} />}
                      sx={{
                        marginTop: "-40px",
                        bgcolor: "#25bdbe",
                        textAlign: "left",
                        color: "black",
                        height: "90px",
                        width: isMobileOrTablet ? "700px" : "380px", // Responsive width
                        marginLeft: isMobileOrTablet ? "0px" : "-9px",
                        fontSize: "20px",
                        textTransform: "none",
                        fontFamily: "caladea",
                        display: "flex",
                        paddingBottom: "40px",
                        justifyContent: "space-between",
                        paddingX: 2,
                        "& .MuiButton-endIcon": {
                          marginLeft: "auto",
                          color: "black",
                        },
                        "&:hover": {
                          bgcolor: "#25bdbe",
                          cursor: "default",
                        },
                      }}
                    >
                      Enter new category
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddIcon style={{ fontSize: "56px" }} />}
                      sx={{
                        background: "#2f2f2f",
                        color: "white",
                        fontSize: "20px",
                        height: 52,
                        width: isMobileOrTablet ? "700px" : "380px",
                        marginTop: "-50px",
                        marginLeft: isMobileOrTablet ? "0px" : "-9px",
                        fontFamily: "caladea",
                        fontWeight: "bold",
                        textTransform: "none"
                      }}
                      onClick={handleAddCategoryDialogOpen}
                    >
                      ADD CATEGORY
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{ textAlign: "center" }}
        PaperProps={{
          sx: { borderRadius: "16px", height: '45%' },
        }}>
        <DialogTitle sx={{ textAlign: "center", color: "#25bdbe", fontFamily: "Caladea, serif", fontSize: "40px", fontWeight: "bold" }}>Confirm Delete</DialogTitle>
        <DialogContent sx={{ textAlign: "center", color: "black", fontFamily: "Caladea, serif", fontSize: "35px", fontWeight: "bold" }}>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              Are you sure you want to delete this product?</Grid></Grid></DialogContent>
        <DialogActions>
          <Grid container spacing={2} sx={{ mb: 5 }}>
            <Grid item xs={6}>
              <Button onClick={() => setDeleteDialogOpen(false)} sx={{
                height: "68px",
                justifyContent: "center",
                alignItems: "center",
                textTransform: "none",
                bgcolor: "#25bdbe",
                width: "80%",
                color: "black",
                border: "1px solid black",
                fontSize: "30px",
                borderRadius: "8px",
                fontWeight: "bold",
                fontFamily: "Caladea, serif",
              }}>Cancel</Button></Grid>
            <Grid item xs={6}>
              <Button onClick={() => handleDelete(productToDelete)} color="error" sx={{
                height: "68px",
                justifyContent: "center",
                alignItems: "center",
                textTransform: "none",
                bgcolor: "grey",
                width: "80%",
                color: "white",
                border: "1px solid black",
                fontSize: "30px",
                borderRadius: "8px",
                fontWeight: "bold",
                fontFamily: "Caladea, serif",
              }}>Delete</Button></Grid></Grid>
        </DialogActions>
      </Dialog>

      {/* Add Category Dialog */}
      <Dialog
        open={addCategoryDialogOpen}
        onClose={handleAddCategoryDialogClose}
        maxWidth="sm"
        fullWidth
        sx={{ textAlign: "center" }}
        PaperProps={{
          sx: { borderRadius: "16px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <Button
            variant="contained"
            sx={{
              textAlign: "center",
              fontSize: "20px",
              fontWeight: "bold",
              fontFamily: "Caladea, serif",
              bgcolor: "#25bdbe",
              color: "black",
              width: "50%",
              padding: "10px",
            }}
          >
            Add New Category
          </Button>
          <Button
            variant="contained"
            sx={{
              textAlign: "center",
              fontSize: "20px",
              backgroundColor: "rgb(41, 43, 43)",
              fontWeight: "bold",
              fontFamily: "Caladea, serif",
              bgcolor: "grey",
              color: "white",
              width: "50%",
              padding: "10px",
            }}
            onClick={handleEditCategoryDialogOpen} // Open edit category dialog
          >
            Edit Category
          </Button>
        </Box>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                label=""
                placeholder="Enter New category"
                fontSize="35px"
                variant="outlined"
                value={categoryFields.field1}
                onChange={(e) => handleCategoryFieldChange("field1", e.target.value)}
                fullWidth
                size="large"
                InputProps={{
                  startAdornment: (
                    <FaLayerGroup
                      style={{
                        fontSize: "58px",
                        marginRight: "20px",
                        opacity: 2,
                      }}
                    />
                  ),
                  sx: { height: "100px" },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "1px solid black",
                    borderRadius: "8px",
                    fontFamily: "Caladea, serif",
                  },
                  "& .MuiInputBase-input": {
                    fontFamily: "Caladea, serif",
                    fontWeight: "bold",
                    fontSize: "35px",
                  },
                  "& .MuiInputLabel-root": {
                    fontFamily: "Caladea, serif",
                  },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2} sx={{ px: 2, pb: 2 }}>
            <Grid item xs={6}>
              <Button
                variant="contained"
                onClick={handleAddCategoryDialogClose}
                sx={{
                  height: "68px",
                  justifyContent: "center",
                  alignItems: "center",
                  textTransform: "none",
                  bgcolor: "grey",
                  width: "100%",
                  color: "white",
                  border: "1px solid black",
                  fontSize: "30px",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  fontFamily: "Caladea, serif",
                }}
              >
                CANCEL
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={handleCategorySubmit}
                sx={{
                  height: "68px",
                  justifyContent: "center",
                  alignItems: "center",
                  textTransform: "none",
                  bgcolor: "#25bdbe",
                  size: "large",
                  width: "100%",
                  color: "black",
                  fontSize: "30px",
                  border: "1px solid black",
                  fontWeight: "bold",
                  fontFamily: "Caladea, serif",
                  borderRadius: "8px",
                }}
              >
                ADD
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      {/* Edit Category Dialog */}
      <Dialog
        open={editCategoryDialogOpen}
        onClose={handleEditCategoryDialogClose}
        maxWidth="sm"
        fullWidth
        sx={{ textAlign: "center" }}
        PaperProps={{
          sx: { borderRadius: "16px" },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontSize: "30px", fontWeight: "bold", fontFamily: "Caladea, serif" }}>
          Edit Categories
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {categories.map((category, index) => (
              <Grid item xs={12} key={index} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography sx={{ fontFamily: "Caladea, serif", fontSize: "20px", fontWeight: "bold" }}>
                  {category}
                </Typography>
                <IconButton
                  color="error"
                  onClick={() => handleOpenDeleteCategoryDialog(category)} // Open delete confirmation dialog
                >
                  <Delete />
                </IconButton>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleEditCategoryDialogClose}
            sx={{
              textTransform: "none",
              bgcolor: "grey",
              color: "white",
              fontSize: "20px",
              fontWeight: "bold",
              fontFamily: "Caladea, serif",
              borderRadius: "8px",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Category Confirmation Dialog */}
      <Dialog
        open={deleteCategoryDialogOpen}
        onClose={handleCloseDeleteCategoryDialog}
        maxWidth="xs"
        fullWidth
        sx={{ textAlign: "center" }}
        PaperProps={{
          sx: { borderRadius: "16px" },
        }}
      >
        <DialogTitle sx={{ fontSize: "24px", fontWeight: "bold", fontFamily: "Caladea, serif", }}>
          Are you sure you want to delete "{categoryToDelete}"?
        </DialogTitle>
        <DialogActions>
          <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
            <Button
              variant="contained"
              onClick={handleCloseDeleteCategoryDialog}
              sx={{
                textTransform: "none",
                bgcolor: "grey",
                color: "white",
                marginRight: "50px",
                fontSize: "16px",
                fontWeight: "bold",
                fontFamily: "Caladea, serif",
                borderRadius: "8px",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleConfirmDeleteCategory}
              sx={{
                textTransform: "none",
                bgcolor: "#bb1726",
                color: "white",
                fontSize: "16px",
                fontWeight: "bold",
                fontFamily: "Caladea, serif",
                borderRadius: "8px",
              }}
            >
              OK
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Image Preview Dialog */}
      <Dialog
        open={imagePreviewOpen}
        onClose={() => setImagePreviewOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "50%", background: "transparent", boxShadow: "none" }
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
            minWidth: "300px",
            borderRadius: "50%",
            p: 2,
          }}
          onClick={() => setImagePreviewOpen(false)}
        >
          <img
            src={previewImageSrc}
            alt="Preview"
            style={{
              width: "250px",
              height: "250px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "6px solid white",
              boxShadow: "0 0 24px 0 rgba(0,0,0,0.5)",
              background: "white"
            }}
          />
        </Box>
      </Dialog>

      {/* Success Dialog */}
      <Dialog
        open={addSuccessDialogOpen}
        onClose={() => setAddSuccessDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "16px", textAlign: "center", p: 2 }
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 3 }}>
          <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" fill="#4caf50"/>
            <path d="M7 13l3 3 7-7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <Typography variant="h6" sx={{ color: "#4caf50", fontWeight: "bold", mt: 2 }}>
            Product Added Successfully!
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 2, bgcolor: "#4caf50", color: "white", fontWeight: "bold" }}
            onClick={() => setAddSuccessDialogOpen(false)}
          >
            OK
          </Button>
        </Box>
      </Dialog>

      {/* Error Dialog for duplicate product name */}
      <Dialog
        open={errorDialog.open}
        onClose={() => setErrorDialog({ ...errorDialog, open: false })}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "16px", textAlign: "center", p: 2 }
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 3 }}>
          {/* Red X SVG */}
          <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" fill="#f44336"/>
            <path d="M15 9l-6 6M9 9l6 6" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <Typography variant="h6" sx={{ color: "#f44336", fontWeight: "bold", mt: 2 }}>
            {errorDialog.message}
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 2, bgcolor: "#f44336", color: "white", fontWeight: "bold" }}
            onClick={() => setErrorDialog({ ...errorDialog, open: false })}
          >
            OK
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

export default SetProduct;